// These polyfills are required for IE11 support
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
// Shared component styles
import '@sa/bff-webchat-ui/dist/components/bffAnswerAdaptiveCard.css';
import '@sa/bff-webchat-ui/dist/components/LoadingState/LoadingState.css';
import '@sa/bff-webchat-ui/dist/components/bffButtonLink.css';

import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

ReactDOM.render(<App />, document.getElementById('webchat'));
